import type { Exercise, PainMap, TodayGapSets, TodaySession } from "@heraion/shared";

import { HomeHero } from "../Home/HomeHero";
import type { StartBuiltSessionInput } from "../Logger/useWorkoutStarter";
import type { UiTheme } from "../theme";
import { CreateHubActions } from "./CreateHubActions";

// The athlete's «Start» block of the Create hub (AP-9b), one tree for mobile
// and web-rnw. D3: today's plan session on top, in HomeHero's shape, with the
// only accent on screen. D1: «Build today's session» as the third row, from
// the SAME coverage the Progress card reads. The mounts own the data hooks,
// the platform theme and the callbacks; this only lays them out.
// Antenore 07/10: the row always opens the draft. The rest choice and the
// «every muscle rests» card live there, with the other chips. #540: and the
// bodyweight toggle.
export type CreateHubStartBodyProps = {
  theme: UiTheme;
  today: TodaySession | null;
  /** Today's draft gaps off the coverage (usePlanGapsCoverage). Null until
   *  the session results are in. */
  planToday: (() => TodayGapSets) | null;
  catalog: ReadonlyArray<Exercise> | null;
  painMap?: PainMap;
  resolveName: (slug: string, snapshot?: string) => string;
  /** The id `useWorkoutStarter` is launching, if any. */
  starting: string | null;
  onNewWorkout: () => void;
  onRepeatWorkout?: () => void;
  onPlanProgram: () => void;
  onPlanWorkout: () => void;
  onStartToday: (today: TodaySession) => void;
  onBuildToday: (input: StartBuiltSessionInput) => void;
};

export function CreateHubStartBody({
  theme,
  today,
  planToday,
  catalog,
  painMap,
  resolveName,
  starting,
  onNewWorkout,
  onRepeatWorkout,
  onPlanProgram,
  onPlanWorkout,
  onStartToday,
  onBuildToday,
}: CreateHubStartBodyProps) {
  return (
    <CreateHubActions
      theme={theme}
      onNewWorkout={onNewWorkout}
      onRepeatWorkout={onRepeatWorkout}
      // Present once the session results are in: before that there is no
      // coverage to build from, and a row that does nothing is worse than none.
      onBuildToday={
        catalog && planToday
          ? () => onBuildToday({ ...planToday(), catalog, painMap })
          : undefined
      }
      onPlanProgram={onPlanProgram}
      onPlanWorkout={onPlanWorkout}
      todaySession={
        today ? (
          <HomeHero
            inSheet
            today={today}
            resolveName={resolveName}
            theme={theme}
            loading={false}
            isStarting={starting === today.program.id}
            onStartToday={() => onStartToday(today)}
            onNewWorkout={onNewWorkout}
          />
        ) : undefined
      }
    />
  );
}
